import { AmericanCountryList, EuropeanUnionList } from '../../constants/quote';
export var getJoveBankInformationByCountryCode = function getJoveBankInformationByCountryCode(config) {
  var _config$countryCode;

  var normalizedCountryCode = (config === null || config === void 0 ? void 0 : (_config$countryCode = config.countryCode) === null || _config$countryCode === void 0 ? void 0 : _config$countryCode.toUpperCase()) || '';

  if (AmericanCountryList.includes(normalizedCountryCode)) {
    return [{
      key: 'companyName',
      title: 'Company name',
      content: 'Jove Technology US Inc'
    }, {
      key: 'accountNumber',
      title: 'Account Number',
      content: '608007665'
    }, {
      key: 'routingNumber',
      title: 'Routing Number',
      content: '021000021'
    }, {
      key: 'address',
      title: 'Address',
      content: '870 MONTAUK HIGHWAY BAY POINT, NY 11705'
    }];
  }

  if (EuropeanUnionList.includes(normalizedCountryCode) || normalizedCountryCode === 'EU') {
    return [{
      key: 'companyName',
      title: 'Company name',
      content: 'JOVE EU, Unipessoal, Lda.'
    }, {
      key: 'iban',
      title: 'IBAN',
      content: 'PT50 0033 0000 4572 1366 6160 5'
    }, {
      key: 'accountNumber',
      title: 'Account Number',
      content: '0000045721366616'
    }];
  }

  return [{
    key: 'companyName',
    title: 'Company name',
    content: 'Jove Technology Limited'
  }, {
    key: 'bankName',
    title: 'Bank Name',
    content: 'MetroBank'
  }, {
    key: 'accountNumber',
    title: 'Account Number',
    content: '44180367'
  }, {
    key: 'sortCode',
    title: 'Sort Code',
    content: '23 05 80'
  }];
};